// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../getDaysInYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var getDaysInYear = convertToFP(fn, 1);
export default getDaysInYear;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/getDaysInYear/index.js
// module id = 893
// module chunks = 0